import { Modal } from "shared/UI/Modal/Modal";
import { ReactComponent as CrossIcon } from "shared/assets/Icons/cross.svg";
import { useTranslation } from "react-i18next";
import { ExperienceFeedback } from "./ExperienceFeedback";

interface ExperienceModalProps {
  title?: string;
  description?: string;
  message?: string;
  isVisible: boolean;
  onPositive: () => any;
  onNegative: () => any;
  onDismiss: () => any;
}

export const ExperienceModal = ({ title, description, message, isVisible, onPositive, onNegative, onDismiss }: ExperienceModalProps) => {
  const { t } = useTranslation();

  if (!isVisible) return null;

  return (
    <Modal width="xs">
      <div data-testid="experience-modal" className="text-center relative p-6">
        <button
          data-testid="experience-modal-dismissed"
          aria-label={t("experienceModal.dismiss")}
          onClick={onDismiss}
          className="absolute z-10 w-4 h-4 top-4 right-4"
        >
          <CrossIcon className="fill-brand-grey hover:fill-brand-grey-light" />
        </button>
        <div className="space-y-6 py-6">
          {title && <h2>{title}</h2>}
          {description && <p>{description}</p>}
          <ExperienceFeedback message={message} onPositive={onPositive} onNegative={onNegative} />
        </div>
      </div>
    </Modal>
  );
};
